import BRTImageModule from './BRTImageGrid';

export default BRTImageModule;